import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from 'redux/store';

import BackdropLoading from 'components/BackdropLoading';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { accessToken, refreshToken, usuario } = useSelector(
    (state: RootState) => state.token,
  );

  const { _persist } = useSelector((state: any) => state);

  // Aguarda reidratação completa
  if (!_persist?.rehydrated) return <BackdropLoading />;

  const isTokenValid = !!accessToken && !!refreshToken;
  const canUseEditor = usuario?.contratante?.utilizaEditor;

  if (!isTokenValid || !usuario) {
    return <Navigate to="/logon?logout=true" replace />;
  }

  if (!canUseEditor) {
    return <Navigate to="/error" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
